import { useEffect, useState } from 'react';

// Responsive primitive — true at/below the breakpoint (default 768px). SSR-safe (guards
// `window`). All mobile-only layout branches gate on this so desktop (≥769px) is unchanged.
export function useIsMobile(bp = 768): boolean {
  const q = `(max-width:${bp}px)`;
  const [m, setM] = useState(() => typeof window !== 'undefined' && window.matchMedia(q).matches);
  useEffect(() => {
    const mq = window.matchMedia(q);
    const on = () => setM(mq.matches);
    mq.addEventListener('change', on);
    setM(mq.matches);
    return () => mq.removeEventListener('change', on);
  }, [q]);
  return m;
}
